import { formatNumber } from '@angular/common';
import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { Area } from 'app/shared/ll/models/units';

@Pipe({
    name: 'area',
})
export class AreaPipe implements PipeTransform {

    constructor(@Inject(LOCALE_ID) private locale: string) {}

    transform(value: any, decimals = 2): any {
        if (!Number.isFinite(value)) {
            return;
        }
        const area = new Area(value);
        const i = area.getQuantity(true);
        const m = area.getQuantity(false);
        const iValue = formatNumber(i.value, this.locale, `1.${decimals}-${decimals}`);
        const mValue = formatNumber(m.value, this.locale, `1.${decimals}-${decimals}`);
        return `${iValue} ${i.unit} / ${mValue} ${m.unit}`;
    }
}
